import { ArrowRight } from 'lucide-react';

const SLUG_ALIASES = {
  ai: 'ai-advisory',
  'ai-services': 'ai-advisory',
  data: 'data-advisory',
  'data-governance': 'data-advisory',
  'data-services': 'data-advisory',
  agentic: 'agentic-ai-advisory',
  'agentic-ai': 'agentic-ai-advisory',
  'agentic-ai-services': 'agentic-ai-advisory',
};

const resolveServiceSlug = (slug) => SLUG_ALIASES[slug] || slug;

const accents = {
  'ai-advisory': {
    bar: 'bg-amber-500',
    pill: {
      dark: 'bg-amber-500/20 text-amber-200 border border-amber-500/40',
      light: 'bg-amber-50 text-amber-900 border border-amber-200',
    },
    border: { dark: 'border-amber-500/25 hover:border-amber-500/45', light: 'border-amber-200 hover:border-amber-300' },
    surface: { dark: 'bg-slate-900/50', light: 'bg-white' },
    cta: { dark: 'text-amber-400 group-hover:text-amber-300', light: 'text-amber-700 group-hover:text-amber-800' },
  },
  'data-advisory': {
    bar: 'bg-cyan-500',
    pill: {
      dark: 'bg-cyan-500/20 text-cyan-100 border border-cyan-500/40',
      light: 'bg-cyan-50 text-cyan-900 border border-cyan-200',
    },
    border: { dark: 'border-cyan-500/25 hover:border-cyan-500/45', light: 'border-cyan-200 hover:border-cyan-300' },
    surface: { dark: 'bg-slate-900/50', light: 'bg-white' },
    cta: { dark: 'text-cyan-400 group-hover:text-cyan-300', light: 'text-cyan-700 group-hover:text-cyan-800' },
  },
  'agentic-ai-advisory': {
    bar: 'bg-indigo-500',
    pill: {
      dark: 'bg-indigo-500/20 text-indigo-100 border border-indigo-500/40',
      light: 'bg-indigo-50 text-indigo-900 border border-indigo-200',
    },
    border: { dark: 'border-indigo-500/25 hover:border-indigo-500/45', light: 'border-indigo-200 hover:border-indigo-300' },
    surface: { dark: 'bg-slate-900/50', light: 'bg-white' },
    cta: { dark: 'text-indigo-400 group-hover:text-indigo-300', light: 'text-indigo-700 group-hover:text-indigo-800' },
  },
};

const defaultAccent = accents['ai-advisory'];

const ServiceCatalogCard = ({ service, theme, onClick, ctaLabel = 'View details' }) => {
  const isDark = theme === 'dark';
  const mode = isDark ? 'dark' : 'light';
  const canonicalSlug = resolveServiceSlug(service.slug);
  const accent = accents[canonicalSlug] || defaultAccent;
  const disciplineLabel = (service.icon || canonicalSlug.split('-')[0] || 'advisory').toUpperCase();

  return (
    <button
      type="button"
      onClick={onClick}
      className={`group w-full text-left rounded-2xl border overflow-hidden transition-all duration-300 hover:-translate-y-1 ${accent.border[mode]} ${accent.surface[mode]} ${
        isDark ? 'shadow-none hover:shadow-lg hover:shadow-black/20' : 'shadow-sm hover:shadow-xl'
      }`}
    >
      <div className="flex h-full">
        <div className={`w-1.5 flex-shrink-0 ${accent.bar}`} aria-hidden />
        <div className="flex flex-col justify-between flex-1 p-8">
          <div>
            <span className={`inline-block px-2.5 py-1 rounded-full text-[11px] uppercase tracking-[0.22em] font-semibold mb-4 ${accent.pill[mode]}`}>
              {disciplineLabel}
            </span>
            <h3 className={`text-xl font-semibold mb-3 ${isDark ? 'text-white' : 'text-slate-900'}`}>
              {service.title}
            </h3>
            <p className={`text-base leading-relaxed ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
              {service.shortDescription}
            </p>
          </div>
          <span className={`mt-8 inline-flex items-center text-sm font-semibold ${accent.cta[mode]}`}>
            {ctaLabel}
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-0.5 transition-transform" />
          </span>
        </div>
      </div>
    </button>
  );
};

export default ServiceCatalogCard;
